// Ambuly — central site config. Replace placeholders with real data before launch.
export const SITE = {
  brand: "Ambuly",
  tagline: "Life-saving rides, on demand.",
  legal: {
    companyName: "Ambuly",
    jurisdiction: "India (West Bengal)",
    address: "5/E, 26 Port Blair Line, Barrackpore, Kolkata 120, West Bengal, India",
    email: "support@ambuly.in",
    phone: "",
    emergencyLine: "112",
    effectiveDate: "January 1, 2026",
  },
  nav: [
    { label: "Home", to: "/" },
    { label: "Services", to: "/services" },
    { label: "Pricing", to: "/pricing" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ],
  media: {
    hero: "https://images.unsplash.com/photo-1757921167588-9d505651a467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhbWJ1bGFuY2UlMjB2ZWhpY2xlJTIwcGFyYW1lZGljfGVufDB8fHx8MTc3NzY0MjQ5OXww&ixlib=rb-4.1.0&q=85",
    heroFallback: "https://images.unsplash.com/photo-1586580827130-e7e51ab33a7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhbWJ1bGFuY2UlMjB2ZWhpY2xlJTIwcGFyYW1lZGljfGVufDB8fHx8MTc3NzY0MjQ5OXww&ixlib=rb-4.1.0&q=85",
    emergency: "https://images.unsplash.com/photo-1758404958502-44f156617bae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxob3NwaXRhbCUyMGVtZXJnZW5jeSUyMHJvb20lMjBuaWdodHRpbWV8ZW58MHx8fHwxNzc3NjQyNTExfDA&ixlib=rb-4.1.0&q=85",
    transport: "https://images.unsplash.com/photo-1641403555984-d953988ca60c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhbWJ1bGFuY2UlMjB2ZWhpY2xlJTIwcGFyYW1lZGljfGVufDB8fHx8MTc3NzY0MjQ5OXww&ixlib=rb-4.1.0&q=85",
    professional: "https://images.unsplash.com/photo-1581056771107-24ca5f033842?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwcHJvZmVzc2lvbmFsJTIwcGF0aWVudCUyMGNhcmV8ZW58MHx8fHwxNzc3NjQyNTAwfDA&ixlib=rb-4.1.0&q=85",
    pattern: "https://images.pexels.com/photos/29506607/pexels-photo-29506607.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};

export default SITE;
